import { render, staticRenderFns } from "./NguoiDungForm.vue?vue&type=template&id=491feb53&"
import script from "./NguoiDungForm.vue?vue&type=script&lang=js&"
export * from "./NguoiDungForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports